// Label colours come from the meta repo's label roles (repos.yaml `labels`, as the API gives them
// in Board.repos[].labels, MetaRepo.labels and Record.labels), never from a label's name.
import { createContext, useContext } from 'react';

/** Label names by role (bug, needs_triage, hold, …); "" = unused. */
export type LabelRoles = { [role: string]: string };

export type LabelTone = 'label-bug' | 'label-triage' | 'label-hold' | 'label-plain';

const TONES: [role: string, tone: LabelTone][] = [
  ['bug', 'label-bug'],
  ['needs_triage', 'label-triage'],
  ['hold', 'label-hold'],
];

/** The tone class for a label: its role's, or plain for a label no coloured role names. */
export function labelTone(name: string, roles: LabelRoles | undefined): LabelTone {
  for (const [role, tone] of TONES) if (roles?.[role] && roles[role] === name) return tone;
  return 'label-plain';
}

/** Each meta repo's label roles, by meta repo id (the board provides them from Board.repos). */
export const LabelRolesByRepo = createContext<{ [repo: number]: LabelRoles }>({});

export function useLabelRoles(repo: number): LabelRoles | undefined {
  return useContext(LabelRolesByRepo)[repo];
}
